export const LABELS = {
  mutationErrorMessage: 'Something went wrong while setting the field value. Please try again.',
  loadingFieldsTooltipMessage: "Couldn't load issue fields",
  loadingFieldsErrorMessage:
    "We couldn't load the issue fields. Please try again later or if the problem persists contact support",
  setValue: 'None yet',
  emptyValueLabels: {
    text: 'Enter text…',
    number: 'Enter number…',
    date: 'Choose a date',
    singleSelect: 'Choose an option',
  },
  reloadWarningMessage: 'Reload site? Changes you made might not be saved.',

  textValidationMaxLength: (length: number, maxLength: number) =>
    `Value cannot be more than ${maxLength} characters (${length})`,
  textValidationEmpty: 'Text cannot be empty.',
  textEditorLabel: (fieldName: string) => `The value for the ${fieldName} field`,
  textEditorToolbarLabel: (fieldName: string) => `Toolbar for ${fieldName} field`,
  textEditorPlaceholder: 'Enter text…',
  numberEditorPlaceholder: 'Enter number…',
  numberValidation: {
    errorMessage: 'Must contain only numbers, decimals, and optional negative sign',
    max: (max: number) => `Cannot be greater than ${max}`,
    min: (min: number) => `Cannot be less than ${min}`,
  },
  textEditorUpdateButton: 'Update',
  textEditorRemoveFieldButtonLabel: (fieldName: string) => `Remove field ${fieldName}`,
  textEditorUpdateButtonAriaLabel: (fieldName: string) => `Update field ${fieldName} (press enter to submit)`,
  textEditorCancelButton: 'Cancel',
  errorUpdatingIssueField: 'There was an error updating this value. Please try again.',
  editFieldValueLabel: (title: string) => `Edit ${title}`,
  noPinnedFieldsMessage: (issueTypeName?: string | null) =>
    issueTypeName ? `No fields configured for ${issueTypeName}.` : 'No fields configured for issues without a type.',
  visibilityIndicatorTooltip: 'Field is visible to the public.',
}
